export const INITIALIZATION_ACTION_SOURCE = 'Spaces_ActivityFeed_Initialization';
